import * as api from 'app/shared/api';
import { Dispatch } from 'redux';
import { Action } from 'app/pages/AgentSearch/actionTypes';
import { pageLoaded } from 'app/pages/AgentSearch/actions';

export function loadPage(dispatch: Dispatch<Action>) : Promise<void> {
    const searchTerm = sessionStorage.getItem('AgentSearchTerm') || '';
    if (searchTerm === '') {
        return Promise.resolve()
            .then(x => { dispatch(pageLoaded('', [])) }); 
    }
    
    return api.searchAgents(searchTerm, false, 50)
        .then(x => { dispatch(pageLoaded(searchTerm, x)) })
        .catch(x => {dispatch(pageLoaded('', [])) });  
}